import React from "react";
import { List, OrderedMap } from "immutable";
import DataSyncForm from "./forms/visibility-req-form";
import CompanyService from "./services/company-los-services";
import { fetchDataSyncRequest } from "./actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import CreateCompanyForm from "./forms/create-distributor-form";
import { Modal, message, Tabs } from "antd";
import RequestTable from "./previous-visibility-requests-list";
export const BASE_URL = (function() {
    return process.env.BASE_URL;
})();

const { TabPane } = Tabs;

class DataSyncDisplay extends React.Component {

    state = {
        casesList: new List([]),
        master_erps: [],
        values: new OrderedMap({}),
        loading: false,
        tableLoading: false,
        initialLoading: true,
        companyId: null,
        associates: new List([]),
        requests: new List([]),
        pageNo: 1,
        page_size: 20,
    }
    formRef = React.createRef();

    componentDidMount() {
        CompanyService.getERPSoftware().then(({ data }) => {
            this.setState({
                master_erps: [...data, { name: "Other", is_sync_possible: false, key: "other" }],
                initialLoading: false
            });
        });
    }

    openDistributorModal = () => {
        this.setState({
            showDistributorModal: true
        });
    }

    closeDistributorModal = () => {
        this.setState({
            showDistributorModal: false
        });
    }

    callAction = async (values, type) => {
        if (type === "CREATE_ASSOCIATE") {
            try{    
                const applicant = await CompanyService.createUpdateCompanyLosSpocUser(values.companyId, [{
                    first_name: values.first_name,
                    last_name: values.last_name,
                    phone: values.phone,
                    designation: values.designation,
                    company: values.companyId,
                    id: null
                }]);
                values.contact_person = applicant.data[0].id;
                const { error } = await CompanyService.generateDataSyncRequest(values.companyId, values);
                if (error || applicant.error) {
                    message.error("Failed to Create Request");    
                } else {
                    message.success("Request submitted successfully");
                    this.formRef.current.resetFields();
                }
            }catch (error){
                message.error({
                    content: <a href={BASE_URL + "/company/ledger_mapping_sample"} onClick={() => console.log("in anchor click")}>{error.field_error && error?.field_error.length && error?.field_error[0] || error[Object.keys(error)]  && error[Object.keys(error)][0] || "Please enter correct data"}</a>
                });
            }
        } else if (type === 1) {
            try{
                const { error} = await CompanyService.generateDataSyncRequest(values.companyId, values);
                if (error) {
                    message.error("Failed to Create Request");    
                } else {
                    message.success("Request submitted successfully");
                    this.formRef.current.resetFields();
                }
            }catch (error){
                message.error({
                    content: <a href={BASE_URL + "/company/ledger_mapping_sample"} onClick={() => console.log("in anchor click")}>{error.field_error && error?.field_error.length && error?.field_error[0] || error[Object.keys(error)]  && error[Object.keys(error)][0] || "Please enter correct data"}</a>
                });
            }
        } else {
            try{
                const { data, error } = await CompanyService.generateDataSyncRequest(values.companyId, values);
                let formData = new FormData();
                values.files.map(_ => formData.append("files", _));
                formData.append("company_erp_data_request_id", data.id);
                formData.append("mapping", values.mapping);
                const bulkUpload = await CompanyService.ledgersUpload(values.companyId, formData);
                if (error || bulkUpload.error) {
                    message.error("Failed to Create Request");    
                } else {
                    message.success("Request submitted successfully");
                    this.formRef.current.resetFields();
                }
            }catch (error){
                message.error({
                    content: <a href={BASE_URL + "/company/ledger_mapping_sample"} onClick={() => console.log("in anchor click")}>{error.field_error && error?.field_error.length && error?.field_error[0] || error[Object.keys(error)]  && error[Object.keys(error)][0] || "Please enter correct data"}</a>
                });
            }
        }

        this.setState({
            loading: false
        });
    }

    onSubmit = (values) => {
        this.setState({
            values: new OrderedMap(values),
            loading: true
        });
        if (!values.erp_software.is_sync_possible) {
            let data = {
                companyId: values.companyId,
                files: values.files,
                mapping: values.mapping,
                erp_software: values.erp_software.id,
                erp_name: values.erp_name,
                request_type: 2
            };
            this.callAction(data, 2);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 2
        ) {
            let data = {
                companyId: values.companyId,
                erp_software: values.erp_software.id,
                request_type: values.request_type.id,
                files: values.files,
                mapping: values.mapping,
            };
            this.callAction(data, 2);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 1 &&
            values.contact_person &&
            values.contact_person.id
        ) {
            let data = {
                companyId: values.companyId,
                erp_software: values.erp_software.id,
                request_type: values.request_type.id,
                contact_person: values.contact_person.id,
                scheduled_at: new Date(
                    `${values.date.format("YYYY-MM-DD")} ${values.time.format("HH:mm")}`
                )
            };
            this.callAction(data, 1);
        } else if (
            values.erp_software.is_sync_possible &&
            values.request_type &&
            values.request_type.id === 1 &&
            !values.contact_person &&
            values.first_name &&
            values.last_name &&
            values.phone &&
            values.designation
        ) {
            let data = {
                companyId: values.companyId,
                erp_software: values.erp_software.id,
                scheduled_at: new Date(
                    `${values.date.format("YYYY-MM-DD")} ${values.time.format("HH:mm")}`
                ),
                first_name: values.first_name,
                last_name: values.last_name,
                phone: values.phone,
                designation: values.designation,
                request_type: values.request_type.id
            };
            this.callAction(data, "CREATE_ASSOCIATE");
        } else {
            return;
        }
    }

    onChangeTab = (val) => {
        if(val === "request-table") {
            this.setState({
                tableLoading: true
            }, () => {
                CompanyService.getSyncRequest(null, this.state.pageNo, null, true, this.state.page_size).then((res) => {
                    this.setState({
                        requestsCount: res?.data?.count,
                        requests: new List(res.data?.results),
                        tableLoading: false
                    });
                });
            });
        }
    }
    paginationFn = (pageNo, pageSize) => {
        this.setState({
            tableLoading : true
        }, () => {
            CompanyService.getSyncRequest(null, pageNo, null, true, pageSize).then((res) => {
                this.setState({
                    requests: new List(res.data.results),
                    tableLoading: false
                });
            }).catch((err) => {
                this.setState({
                    tableLoading: false
                });
                console.log("err", err);
            });
        });
    }

    render() {
        return (
            <React.Fragment>
                <Modal
                    title={"Add Distributor"}
                    visible={this.state.showDistributorModal}
                    footer={null}
                    onCancel={this.closeDistributorModal}
                >
                    {this.state.showDistributorModal && <CreateCompanyForm
                        closeDistributorModal={this.closeDistributorModal}
                    />}
                </Modal>
                <Tabs defaultActiveKey={"form"} onChange={this.onChangeTab} >
                    <TabPane key={"form"} tab={"Create New Request"}>
                        <DataSyncForm
                            ref={this.formRef}
                            loading={this.state.loading}
                            values={this.state.values}
                            onSubmit={this.onSubmit}
                            onSelectCompany={this.getSyncRequestData}
                            associates={this.state.associates}
                            master_erps={this.state.master_erps}
                            openDistributorModal={this.openDistributorModal}
                        />
                    </TabPane>
                    <TabPane key={"request-table"} tab={"Previous Requests"}>
                        <RequestTable
                            requests={this.state.requests}
                            requestsCount= {this.state.requestsCount}
                            tableLoading={this.state.tableLoading}
                            pagination={this.paginationFn}
                        />
                    </TabPane>
                </Tabs>
            </React.Fragment>
        );
    }
}

DataSyncDisplay.propTypes = {
    fetchDataSyncRequest: PropTypes.func,
    dataSyncRequest: PropTypes.string
};

const mapStateToProps = () => {
    return ({
        // dataSyncRequest: state.com.getIn(["dataSyncRequest", "status"]) || STATE_STATUS.UNFECTHED,
        // gstin: state.companyLosProfiles.getIn(["profiles", props.companyId, "data", "gstin"])
    });
};

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchDataSyncRequest
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DataSyncDisplay);